import {ContentState, convertFromHTML, convertFromRaw, convertToRaw, EditorState} from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import * as RasaChromePicker from '../../../components/chrome-picker'
import * as Form from '../../../components/form'
import * as Modal from '../../../components/modal'
import * as Constants from './constants'
import * as Types from './types'

const modalReducerEvent: Modal.ReducerEvent<{}> = {
  initializeState: () => ({}),
  requestEvent: Constants.ADD_LEAD_TEXT_MODAL,
  toggleEvent: Constants.FormConstants[Form.ENTER],
}
export const modalReducer = Modal.reducer(modalReducerEvent)

export const formReducer  = Form.createReducer(Constants.ADD_LEAD_TEXT_MODAL)

export const handleEditorState = (value: Types.FormFields) => {
  if (value.editor_state) {
    // Create local EditorState from previous snapshot of saved EditorState
    const contentState = convertFromRaw(value.editor_state)
    return EditorState.createWithContent(contentState)
  } else if (value.description) {
    // Here we only have html, so convert it to Draft.js EditorState
    const blocksFromHTML = convertFromHTML(value.description)
    const createdState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)
    return EditorState.createWithContent(createdState)
  }
  return EditorState.createEmpty()
}

export const editorStateReducer = (state: Types.EditorState = Constants.emptyEditorState, action: any) => {
  switch (action.type) {
    case Constants.FormConstants[Form.ENTER]:
      const selectedLeadText = action.value ? action.value : Constants.emptySelectedLeadText
      const splitBorder = action.value.styles &&
                          action.value.styles.border ? action.value.styles.border.split(/[ ]+/) : []
      return {
        ...state,
        border: {
          ...state.border,
          color: splitBorder[2] || RasaChromePicker.DEFAULT_COLOR,
          size: splitBorder[0] || '0px',
        },
        editorState: handleEditorState(action.value),
        selectedLeadText,
        styleObject: action.value.styles || Constants.emptyStyleObject,
      }
    case Constants.UPDATE_EDITOR_STATE:
      const rawState = convertToRaw(action.editorState.getCurrentContent())

      // Yuck: The old wysiwyg editor had option to left/center/right align
      // images.  But it implemented the "center" as "none", which meant it
      // ended upleft-aligning images.  So hacking - when we find that condition
      // explicitly set it to none.  This fixes the generated HTML.
      //
      // CSS has a corresponding workaround for this same issue in the preview section.
      Object.keys(rawState.entityMap).forEach((key: any) => {
        const em: any = rawState.entityMap[key]
        if ( em.type === 'IMAGE' && em.data.alignment === 'none' ) {
          em.data.alignment = 'center'
        }
      })

      const html: string = draftToHtml(rawState)
      return {
        ...state,
        editorState: action.editorState,
        selectedLeadText: {
          ...state.selectedLeadText,
          description: html,
          editor_state: rawState,
        },
      }
    case Constants.LEAD_TEXT_BACKGROUND_COLOR_CHANGE:
      return {
        ...state,
        selectedLeadText: {
          ...state.selectedLeadText,
          styles: {
            ...state.styleObject,
            background: action.color.hex,
          },
        },
        styleObject: {
          ...{
            ...state.styleObject,
            background: action.color.hex,
          },
        },
      }
    case Constants.LEAD_TEXT_BORDER_COLOR_CHANGE:
      return {
        ...state,
        border: {
          ...state.border,
          color: action.color.hex,
        },
        selectedLeadText: {
          ...state.selectedLeadText,
          styles: {
            ...state.styleObject,
            border: `${state.border.size} ${state.border.lineType} ${action.color.hex}`,
          },
        },
        styleObject: {
          ...{
            ...state.styleObject,
            border: `${state.border.size} ${state.border.lineType} ${action.color.hex}`,
          },
        },
      }
    case Constants.LEAD_TEXT_BORDER_SIZE_CHANGE:
      return {
        ...state,
        border: {
          ...state.border,
          size: action.size,
        },
        selectedLeadText: {
          ...state.selectedLeadText,
          styles: {
            ...state.styleObject,
            border: `${action.size} ${state.border.lineType} ${state.border.color}`,
          },
        },
        styleObject: {
          ...{
            ...state.styleObject,
            border: `${action.size} ${state.border.lineType} ${state.border.color}`,
          },
        },
      }
    case Constants.LEAD_TEXT_PADDING_SIZE_CHANGE:
      return {
        ...state,
        selectedLeadText: {
          ...state.selectedLeadText,
          styles: {
            ...state.styleObject,
            padding: action.size,
          },
        },
        styleObject: {
          ...{
            ...state.styleObject,
            padding: action.size,
          },
        },
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/pages/lead-text/add-edit-modal/reducer.ts